import * as React from "react";
import { DialogActions } from "@material-ui/core";

export interface IModalConfirmModalActionsPros {
    children: React.ReactNode;
}

export const ConfirmModalActions:React.FC<IModalConfirmModalActionsPros> = (props) => { 
    return (
        <DialogActions className="share-table-modal-actions">
             {props.children}  
        </DialogActions>
    )
}


// WEBPACK FOOTER //
// ./src/component/shared/confirm-modal/ConfirmModalActions.tsx